import React from "react";
import classNames from "classnames";
import { createStyles, Grid, StandardProps, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import filesize from "filesize";
import moment from "moment";
import { StyleClassKey } from "js/react/typescript";
import { AppPlyr } from "js/react/components";
import MediaManagementProps from "./MediaManagement";
import { MimeType } from "js/models";
import { UIMediaContent } from "./Types";
import { Contents } from "js/models/Media";
import { Cloudinary } from "cloudinary-core"; // If your code is for ES6 or higher

//Cloudinary

//var cloudinary = require("cloudinary-core");

const cl = new Cloudinary({
    cloud_name: "sohaib-teraception",
    secure: true
});

const styles = (theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100%",
            width: "100%"
        },
        main: {
            height: "100%",
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            padding: theme.spacing(1)
        },
        image: {
            maxWidth: "100%",
            maxHeight: "100%"
        },
        metaContainer: {}
    });

const useStyles = makeStyles(styles);

export interface CreativePreviewProps
    extends StandardProps<{}, StyleClassKey<typeof styles>> {
    content: Contents;
}

export const CreativePreview = (props: CreativePreviewProps) => {
    const classes = useStyles(props);
    const { content } = props;
    return (
        <div className={classNames(classes.root, props.className)}>
            <div className={classes.main}>
                {[MimeType.PNG, MimeType.GIF, MimeType.JPEG].includes(
                    content.mimeType
                ) && (
                    <img
                        className={classes.image}
                        alt={content.name}
                        src={content.url}
                    />
                )}
                {[MimeType.MP4, MimeType.Webm].includes(content.mimeType) && (
                    <AppPlyr url={content.url} mimeType={content.mimeType} />
                )}
                {/*[
                    MimeType.AAC,
                    MimeType.AAC_OTHER,
                    MimeType.AIFF,
                    MimeType.AIFF_OTHER,
                    MimeType.M4A,
                    MimeType.M4A_OTHER,
                    MimeType.MP3,
                    MimeType.WAV,
                    MimeType.WAV_OTHER
                ].includes(content.mimeType) && (
                    <AppPlyr
                        type="audio"
                        url={content.url}
                        mimeType={content.mimeType}
                    />
                )*/}
            </div>
            {/*<Grid
                container
                spacing={4}
                justify={"center"}
                className={classes.metaContainer}
            >
                <Grid item>Dimensions: {getContentDimensions(content)}</Grid>
                <Grid item>Format: {content.mimeType}</Grid>
                <Grid item>Size: {filesize(content.size)}</Grid>
                {getContentDuration(content) && (
                    <Grid item>
                        Duration:{" "}
                        {(moment.duration(
                            getContentDuration(content),
                            "second"
                        ) as any).format()}
                    </Grid>
                )}
                        </Grid>*/}
        </div>
    );
};
